module.exports = __webpack_public_path__ + "img/home_img_earth.f74370f1.png";